import { switchLocale, useLocale } from "../i18n/LocaleProvider";
import { LOCALE_META, LOCALES } from "../i18n/locale";

/**
 * A little flag, fixed to the top-right corner on every screen, showing the
 * language the site is CURRENTLY in — so the French site flies the French flag.
 * Pressing it CYCLES to the next language (en → fr → el → en), so every language
 * is reachable from the one button.
 *
 * The flag and the action therefore disagree on purpose: the flag is a status
 * light, not a preview of where the button goes. The aria-label and tooltip
 * still describe the action ("Passer en anglais"), because that's what someone
 * who can't see the flag needs to know before pressing it.
 */
export function LocaleSwitcher() {
  const { locale, t } = useLocale();
  // The NEXT language in LOCALES order, wrapping around — so a third language
  // isn't stranded behind a two-way toggle.
  const next = LOCALES[(LOCALES.indexOf(locale) + 1) % LOCALES.length];
  // Name the target language in the CURRENT language: the French page offers
  // "Passer en anglais", not "Passer en English".
  const label = t.switchTo(t.languageName[next]);

  return (
    <button
      className="locale-switcher"
      onClick={() => switchLocale(next)}
      aria-label={label}
      title={label}
    >
      <span className="locale-flag" aria-hidden="true">
        {LOCALE_META[locale].flag}
      </span>
    </button>
  );
}
